import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';
import { AxiosError } from 'axios';
import { EStatusCode } from '@/enums';
import ProjectShareLink from '@/components/projects/single-project/share/ProjectShareLink';
import ProjectSharePanel from '@/components/projects/single-project/share/ProjectSharePanel';
import useErrorStore from '@/store/ErrorStore';
import FullPageLoader from '@/components/atoms/Loader/FullPageLoader';
import ProjectShareTestLink from '@/components/projects/single-project/share/ProjectShareTestLink';
import UnsavedChangesModal from '@/components/Modals/UnsavedChangesModal';
import useCreateProjectStore from '@/store/CreateProjectStore';
import { useCurrentProject } from '@/hooks/useCurrentProject';

function ProjectShare() {
  const { setShowError } = useErrorStore();
  const { isFormChanged } = useCreateProjectStore();

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isFormChanged && currentLocation.pathname !== nextLocation.pathname,
  );

  const {
    currentProject: singleProjectData,
    error: projectDataError,
    isLoading,
  } = useCurrentProject();

  useEffect(() => {
    if ((projectDataError as AxiosError)?.status === EStatusCode.BAD_REQUEST) {
      setShowError(true);
    }
  }, [projectDataError, setShowError]);

  if (blocker.state === 'blocked') return <UnsavedChangesModal blocker={blocker} />;

  if (isLoading) return <FullPageLoader />;

  return (
    <main className="flex flex-col w-full h-full mx-auto pt-5 gap-10">
      <ProjectShareTestLink singleProjectData={singleProjectData!} />
      <ProjectShareLink singleProjectData={singleProjectData!} />
      <ProjectSharePanel singleProjectData={singleProjectData!} />
    </main>
  );
}

export default ProjectShare;
